const globalThis = require("../globalThis");

module.exports = {
  WebSocket: globalThis.WebSocket || globalThis.MozWebSocket,
  usingBrowserWebSocket: true,
  defaultBinaryType: "arraybuffer"
};



//////////////////
// WEBPACK FOOTER
// ./~/engine.io-client/lib/transports/websocket-constructor.browser.js
// module id = 8259
// module chunks = 2